module.exports = __webpack_public_path__ + "static/media/before_n_after_b.5a95c47f.jpg";